import { render, staticRenderFns } from "./LoanLoader.vue?vue&type=template&id=5838c77e"
import script from "./LoanLoader.vue?vue&type=script&lang=js"
export * from "./LoanLoader.vue?vue&type=script&lang=js"
import style0 from "./LoanLoader.vue?vue&type=style&index=0&id=5838c77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports